import * as React from 'react'
import Page from '../../molecules/page'
import PageRoot from '../../molecules/page-root'
import Simple from '../../templates/simple'
import { Root } from './styles'

export const StepWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Simple
      includeFooter={false}
      headerIsDark={false}
      clearErrors={this.onErrorClose}
    >
      <Root>
        <Page>
          <PageRoot>{children}</PageRoot>
        </Page>
      </Root>
    </Simple>
  )
}

export default StepWrapper
